<template>
  <span class="d-none">{{ layout }}</span>
    <component :is="layout">
        <router-view></router-view>
    </component>
</template>

<script>
import AuthLayoutComponent from "./components/layout/Auth/AuthLayoutComponent.vue";
import GuestLayoutComponent from "./components/layout/Guest/GuestLayoutComponent.vue";
// import DocumentationLayoutComponent from "./components/layout/documentation/DocumentationLayoutComponent.vue";

export default {
  name: 'App',
  components:{
    "auth":AuthLayoutComponent,
    "guest":GuestLayoutComponent,
    // "documentation":DocumentationLayoutComponent,
  },
  data() {
    return {
      layout: null,
    };
  },
  mounted(){
      document.body.setAttribute("data-luno", 'theme-green');
      document.documentElement.setAttribute("data-theme", 'light');
  },
  watch: {
    $route: {
        immediate: true, // also trigger handler on initial value
        handler() {
          if (this.$route.meta.layout !== undefined) {
            this.layout = this.$route.meta.layout
          } else {
            this.layout = "guest" // this is default layout if route meta is not set
          }
        }
    },
  }
}
</script>
<style lang="scss">
@import "./assets/scss/luno-style.scss";
</style>